const NapsterLogo = '/images/logo_napster_white.svg'
const NapsterLogoMedium = '/images/NaspterCompanion _Logo_medium.png'

export type BrandConfig = {
  logo: string
  brandName: string
  favicon: string
  id: string
  scope: string
  logoMedium?: string
}

export const NAPSTER_BRAND: BrandConfig = {
  id: 'napster',
  logo: NapsterLogo,
  brandName: 'Napster',
  favicon: 'napsterFav.ico',
  scope: 'napsterai.companions.identity.main',
  logoMedium: NapsterLogoMedium,
}
